import React from 'react'
import { FaDiscord, FaTwitter} from 'react-icons/fa'
import openSeaLogo from '../../images/OpenSeaWhite.svg'
import { animateScroll as scroll } from 'react-scroll'
import { RiFilePaper2Line } from 'react-icons/ri'
import whitePaper from '../../whitepaper.pdf'

import {
  Navbar,
  NavbarContainer,
  NavLogo,
  NavMenu,
  NavItem,
  NavLinks,
  NavSocials,
  SocialItem,
} from './NavElements.js'
import { ButtonWrapper, ConnectButton } from './BrainzShopElements'
import {DISCORD_URL} from "../../App";

const Nav = ({toggleShop, buttonOnClick, buttonText }) => {
  
  const toggleHome = () => {
    scroll.scrollToTop()
  }

    return (
        <>
          <Navbar classname="nav">
            <NavbarContainer>
              <NavLogo to='/' onClick={toggleHome}>Bit Monsters</NavLogo>
              <NavMenu>
                <NavItem>
                  <NavLinks 
                    onClick={() => toggleShop("Reroll")}
                  >Reroll</NavLinks>
                </NavItem>
                <NavItem>
                  <NavLinks
                    onClick={() => toggleShop("Mutate")} 
                  >Mutate</NavLinks>
                </NavItem>
                {/* <NavItem>
                  <NavLinks
                    onClick={() => toggleShop("Stake")} 
                  >Duel Arena</NavLinks>
                </NavItem> */}
              </NavMenu>
              <ButtonWrapper>
                <ConnectButton
                  onClick={buttonOnClick}>
                    {buttonText}
                </ConnectButton>
              </ButtonWrapper>
              <NavSocials>
                <SocialItem to={{ pathname: DISCORD_URL }} target="_blank"><FaDiscord size={30}/></SocialItem>
                <SocialItem to={{ pathname: "https://twitter.com/bit_monsters" }} target="_blank"><FaTwitter size={30}/></SocialItem>
                <SocialItem to={{ pathname: "https://opensea.io/collection/bit-monsters-nft" }} target="_blank"><img src={openSeaLogo} alt="Open Sea Logo"/></SocialItem>
                <SocialItem to={whitePaper} target="_blank"><RiFilePaper2Line size={30}/></SocialItem>
              </NavSocials>
            </NavbarContainer>  
          </Navbar>      
        </>
    )
}

export default Nav
